export enum StringFormatTypes {
  // eslint-disable-next-line no-unused-vars
  Capitalize = 'Capitalize',
  // eslint-disable-next-line no-unused-vars
  Lowercase = 'Lowercase',
  // eslint-disable-next-line no-unused-vars
  Uppercase = 'Uppercase',
}

export enum StringVariationTypes {
  // eslint-disable-next-line no-unused-vars
  Singular = 'Singular',
  // eslint-disable-next-line no-unused-vars
  Plural = 'Plural',
}

export function transformString(value: string | null, stringFormatType: StringFormatTypes) {
  if (!value) {
    return '';
  }
  switch (stringFormatType) {
    case StringFormatTypes.Capitalize:
      return capitalize(value);
    case StringFormatTypes.Uppercase:
      return capitalize(value, true);
    case StringFormatTypes.Lowercase:
      return value.toLowerCase();
    default:
      return capitalize(value);
  }
}

export function capitalize(value: string | null, all = false) {
  if (!value) {
    return '';
  }
  if (all) {
    return value.toUpperCase();
  } else {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
